/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentCityGenericProps {
  cityName: string;
}

export const ContentCityGeneric = ({ cityName }: ContentCityGenericProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Homes for rent in ${cityName}, Netherlands`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Searching for housing in ${cityName}, Netherlands? Kamernet will help you
        browse and find homes for rent in ${cityName}. Use our search filters to
        browse affordable rental properties in ${cityName} within your budget and
        preferences. Whether you're looking for a cozy studio, a spacious
        apartment, or a comfortable family home, we're here to help you every
        step of the way. Start your search for renting a home in the
        Municipality of Rotterdam on Kamernet today!`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Are you specifically looking for a property with mid-range rent in
        ${cityName}? Or do you want to learn more about private rental homes in
        ${cityName}? Kamernet not only offers a wide range of rental homes, but we're
        also here to guide you in finding the best option that fits your budget
        and preferences. Whether it's finding a rental home in the vicinity of
        ${cityName}, discovering affordable rental homes in ${cityName}, or searching for
        a temporary residence in ${cityName}, we're here to assist you at every step
        of your journey.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Do you need help finding living space for rent in ${cityName}? Our dedicated
        team is here to support you. With our extensive range of listings and
        convenient search filters, you'll quickly and easily find the ideal
        living space that suits your needs and budget. Whether you have
        questions about specific neighborhoods, amenities, or rental options,
        we're here to help you at every step of the process. Start your search
        for accommodation in ${cityName} on Kamernet today!`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Huurwoningen in ${cityName}, Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar huurwoningen in ${cityName}, Nederland? Kamernet helpt je bij
        het zoeken en vinden van huizen te huur in ${cityName}. Gebruik onze
        zoekfilters om goedkope woningen te huur in ${cityName} te zoeken binnen jouw
        budget en voorkeuren. Of je nu een gezellige studio, een
        grootappartement of een comfortabele eengezinswoning zoekt, wij staan
        klaar om je te helpen bij elke stap van je zoektocht. Begin vandaag nog
        met je zoektocht naar jouw ideale woning in ${cityName} op Kamernet!`}
      </Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Ben je specifiek op zoek naar middenhuur woning in ${cityName}? Of wil je
        meer weten over particuliere huurwoningen in ${cityName}? Kamernet biedt niet
        alleen een ruim aanbodaan huurwoningen, maar we staan ook klaar om je te
        begeleiden bij het vinden van de beste optie die past bij jouw budget en
        voorkeuren. Of het nu gaat om het vinden van een huurwoning in de
        omgeving van ${cityName}, het ontdekken van goedkope huurwoningen in ${cityName}
        of het zoeken naar een tijdelijke huurwoning in ${cityName}, we zijn hier om
        je te helpen bij elke stap van je woning zoektocht.`}
      </Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Heb je hulp nodig bij het vinden van huurwoning in ${cityName}? Ons toegewijde
        team staat klaar om je te ondersteunen. Met ons uitgebreide aanbod en
        handige zoekfilters vind je snel en eenvoudig de ideale woning die past
        bij jouw behoeften en budget. Of je nu vragen hebt over specifieke
        buurten, voorzieningen of huuropties, we zijn hier om je te helpen bij
        elke stap van het proces. Start vandaag nog met zoeken naar woonruimte
        in ${cityName} op Kamernet!`}
      </Typography>
    </React.Fragment>
  );
};
